"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

const index_1 = require("../../../index");

const AbstractParserWithWordBoundary_1 = require("../../../common/parsers/AbstractParserWithWordBoundary");

const dayjs_1 = require("../../../utils/dayjs");

const dayjs_2 = __importDefault(require("dayjs"));

class PTCasualTimeParser extends AbstractParserWithWordBoundary_1.AbstractParserWithWordBoundaryChecking {
  innerPattern() {
    return /(?:esta\s*)?(manha|manhã|tarde|meia-noite|meio-dia|noite)(?=\W|$)/i;
  }

  innerExtract(context, match) {
    const targetDate = dayjs_2.default(context.refDate);
    const component = context.createParsingComponents();

    switch (match[1].toLowerCase()) {
      case "tarde":
        component.imply("meridiem", index_1.Meridiem.PM);
        component.imply("hour", 15);
        break;

      case "noite":
        component.imply("meridiem", index_1.Meridiem.PM);
        component.imply("hour", 22);
        break;

      case "manha":
      case "manhã":
        component.imply("meridiem", index_1.Meridiem.AM);
        component.imply("hour", 6);
        break;

      case "meia-noite":
        dayjs_1.assignTheNextDay(component, targetDate);
        component.imply("hour", 0);
        component.imply("minute", 0);
        component.imply("second", 0);
        break;

      case "meio-dia":
        component.imply("meridiem", index_1.Meridiem.AM);
        component.imply("hour", 12);
        break;
    }

    return component;
  }

}

exports.default = PTCasualTimeParser;